import axios from 'axios'
let _requestCount = 0 // 请求次数，用于生成requestId
export const request = (object, requestObj) => {
  const { url, data, params, header, timeout, method, dataType, responseType, cookie } = object

  requestObj.id = ++_requestCount // 生成requestId

  const config = {
    method: method || 'POST',
    url: url,
    data: data,
    params: params,
    headers: header || {
      'content-type': 'application/json'
    },
    timeout: timeout || 30000,
    responseType: responseType || 'text',
    withCredentials: cookie
  }
  // if ((method || '').toLocaleLowerCase() == 'get') {
  //   delete config.data
  // }
  // if ((method || '').toLocaleLowerCase() == 'post') {
  //   delete config.params
  // }
  return axios(config)
}
